// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .report-post__form {} */

/* .report-post__form__element {} */

.report-post__form__element__title {
    margin-top: var(--space);
    margin-left: var(--space-and-half);
}

.report-post__form__element__title .baloa-table{
    color: var(--primary-dark-color);
}

.MuiFormControl-root.report-post__form__element__input {    
    margin-top: var(--space-half);
    margin-bottom: var(--space);
    padding-left: var(--space-x2);
    padding-right: var(--space-x2);
    width: 100%;
}

.report-post__form__element__input textarea {
    background: var(--new-input-background-color);
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
    margin: var(--space);
}
/* .report-post__form__element__input label {
    position: absolute;
    background-color: var(--primary-very-light-color);
    font-weight: var(--font-bold);
    font-family: var(--secondary-font);
    line-height: var(--space);
    letter-spacing: 0.004em;
    color: var(--primary-dark-color);
    text-transform: uppercase;
    padding: 0 var(--space-half);
    margin-left: calc(var(--space-x2) * 2);
} */

/* .report-post__form__element__input.MuiFormControl-marginNormal{
    width: calc(var(--space) * 6);
    margin: 0px;
} */

.report-post__form__element__input div{
    padding: 0px;
    border-radius: 9px;
    background: var(--new-input-background-color);
    border: 1px solid var(--new-grey-border-color);
}

/* .report-post__form__element__input .MuiOutlinedInput-input{
    padding: 0px;   
} */

/* .report-post__form__element__input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{
    border: var(--input-field-border);
} */

/* .report-post__form__element__input .MuiInputBase-input{
    min-height: calc(var(--space-x2) * 7);
} */

.report-post__form__actions{
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/app/posts/components/report-modal/ReportModalComponent.styles.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,mCAAmC;;AAEnC;IACI,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,oBAAoB;AACxB;AACA;;;;;;;;;;;GAWG;;AAEH;;;GAGG;;AAEH;IACI,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;IAC7C,8CAA8C;AAClD;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":["/* .report-post__form {} */\n\n/* .report-post__form__element {} */\n\n.report-post__form__element__title {\n    margin-top: var(--space);\n    margin-left: var(--space-and-half);\n}\n\n.report-post__form__element__title .baloa-table{\n    color: var(--primary-dark-color);\n}\n\n.MuiFormControl-root.report-post__form__element__input {    \n    margin-top: var(--space-half);\n    margin-bottom: var(--space);\n    padding-left: var(--space-x2);\n    padding-right: var(--space-x2);\n    width: 100%;\n}\n\n.report-post__form__element__input textarea {\n    background: var(--new-input-background-color);\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    margin: var(--space);\n}\n/* .report-post__form__element__input label {\n    position: absolute;\n    background-color: var(--primary-very-light-color);\n    font-weight: var(--font-bold);\n    font-family: var(--secondary-font);\n    line-height: var(--space);\n    letter-spacing: 0.004em;\n    color: var(--primary-dark-color);\n    text-transform: uppercase;\n    padding: 0 var(--space-half);\n    margin-left: calc(var(--space-x2) * 2);\n} */\n\n/* .report-post__form__element__input.MuiFormControl-marginNormal{\n    width: calc(var(--space) * 6);\n    margin: 0px;\n} */\n\n.report-post__form__element__input div{\n    padding: 0px;\n    border-radius: 9px;\n    background: var(--new-input-background-color);\n    border: 1px solid var(--new-grey-border-color);\n}\n\n/* .report-post__form__element__input .MuiOutlinedInput-input{\n    padding: 0px;   \n} */\n\n/* .report-post__form__element__input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{\n    border: var(--input-field-border);\n} */\n\n/* .report-post__form__element__input .MuiInputBase-input{\n    min-height: calc(var(--space-x2) * 7);\n} */\n\n.report-post__form__actions{\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
